import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYoutubegamingComponent } from './simple-icons-youtubegaming.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYoutubegamingComponent ],
    exports:      [ SimpleIconsYoutubegamingComponent ],
    bootstrap:    []
})
export class SimpleIconsYoutubegamingModule {}
